import axios from "axios";
import Vue from 'vue';
import qs from 'qs'
import merge from 'lodash/merge'
import router from '@/router'

const vm = new Vue()
const methods = ["get", "post"]
const prefix = "/mall/",
	suffix = ".htm"
let ajax = axios.create({
	//超时时间
	timeout: 15000
})
const fetch = {}
ajax.interceptors.request.use(config => {
	// + suffix
	config.url = prefix + config.url
	return config
}, error => {
	return new Promise.reject(error)
})
const errorMsg = {
	400: "请求错误",
	401: "未授权，请重新登录",
	403: "拒绝访问",
	404: "请求错误,未找到该资源",
	405: "请求方法未允许",
	408: "请求超时",
	500: "服务器端出错",
	501: "网络未实现",
	502: "网络错误",
	503: "服务不可用",
	504: "网络超时",
	505: "http版本不支持该请求"
};

ajax.interceptors.response.use(response => {
	if (response.data && response.data.code === "1011") { // 1001, token失效
		router.push({
			name: 'login'
		})
	}
	return response
}, error => {
	// 请求错误时做些事
	if (error && error.response) {
		let errMsg = errorMsg[error.response.status]
		error.message = errMsg ? errMsg : `连接错误${error.response.status}`
	} else {
		error.message = "连接到服务器失败"
	}

	vm.$notify({
		title: '温馨提示',
		message: error.message,
		position: 'top-right'
	});
	return new Promise(error)
})
methods.forEach(item => {
	fetch[item] = function(url, data, config) {
		let loadingInstance;
		if (url.indexOf('User/Login') == -1) {
			//非登录接口请求增加loading
			loadingInstance = vm.$loading({
				text: "数据请求中...",
				target: ".layout_main",
				background: "rgba(255,255,255,.6)"
			})
		}

		return new Promise(function(resolve, reject) {
			ajax[item](url, data, config).then(response => {
				loadingInstance && loadingInstance.close()
				if (response.data.code === "0") {
					resolve(response.data);
				} else {
					vm.$notify({
						title: '温馨提示',
						message: response.data.message,
						position: 'top-right'
					});
					if (response.data.code === '1011') {
						sessionStorage.clear();
						location.reload()
					}
					reject(response.data.message)

				}
			}).catch(error => {
				loadingInstance && loadingInstance.close()
				reject(error.message)
			})
		})
	}
})

var dto = ({
	url,
	methods,
	params,
	data
}) => {
	if (methods == 'get') {
		return fetch.get(url, params);
	} else {
		if (params) {
			return fetch.post(url, params);
		} else {
			return fetch.post(url, data);
		}
	}
};

/**
 * 请求地址处理
 * @param {*} actionName action方法名称
 */
dto.adornUrl = (actionName) => {
	return actionName;
}

/**
 * get请求参数处理
 * @param {*} params 参数对象
 * @param {*} openDefultParams 是否开启默认参数?
 */
dto.adornParams = (params = {}, openDefultParams = false) => {
	var defaults = {
		't': new Date().getTime()
	}
	return openDefultParams ? merge(defaults, params) : params
}

/**
 * post请求数据处理
 * @param {*} data 数据对象
 * @param {*} openDefultdata 是否开启默认数据?
 * @param {*} contentType 数据格式
 *  json: 'application/json; charset=utf-8'
 *  form: 'application/x-www-form-urlencoded; charset=utf-8'
 */
dto.adornData = (data = {}, openDefultdata = false, contentType = 'json') => {
	var defaults = {
		't': new Date().getTime()
	}
	for (var key in data) {
		if (data[key] === '') {
			delete data[key]
		}
	}
	return data;
}


Plugin.install = function(Vue, options) {
	Vue.axios = ajax;
	Vue.http = ajax;
	window.http = ajax;
	window.axios = ajax;
	Object.defineProperties(Vue.prototype, {
		axios: {
			get() {
				return ajax;
			}
		},
		$axios: {
			get() {
				return fetch;
			}
		},
		http: {
			get() {
				return dto;
			}
		},
		$http: {
			get() {
				return dto;
			}
		},
	});
};

Vue.use(Plugin)

export default Plugin;
